module.exports = __webpack_public_path__ + "img/email.593dca72.png";